import React, {useState} from 'react';
import {Button, Form, Input, Modal, Select, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import {TB_STORAGE_MGR} from "./data/StorageWizMgrData";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {formatDate} from "../../../../../Common/util/DateUtil";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {bytesToFileSizeString} from "../../../../../Common/util/FileUtil";
import {EditOutlined} from "@ant-design/icons";

const ArchiveMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`ArchiveMgr`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_STORAGE_MGR[]>(
        queryKey,
        () =>procAdminService<TB_STORAGE_MGR[]>("post", `${serviceCode}ADS15`, null));

    const [storageName, setStorageName] = useState<string>('');
    const [mainPath, setMainPath] = useState<string>('');
    const [limitCnt, setLimitCnt] = useState<number>(1000);
    const [limitFileSize, setLimitFileSize] = useState<number>(2);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [calcFilesize, setCalcFilesize] = useState<string>("GB");
    const [showConfirmBox, setShowConfirmBox]= useState<boolean>(false);
    const [isModifyMode, setIsModifyMode]= useState<boolean>(false);

    const columns: ColumnsType<TB_STORAGE_MGR> = [
        {
            title: '스토리지명',
            dataIndex: 'storageName',
            key: 'storageName',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '스토리지 경로',
            dataIndex: 'mainPath',
            key: 'mainPath',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>

        },
        {
            title: '폴더당 저장개수',
            dataIndex: 'limitCnt',
            key: 'limitCnt',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '폴더당 저장용량',
            dataIndex: 'limitFileSize',
            key: 'limitFileSize',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {bytesToFileSizeString(parseInt(text))}
                </div>

        },
        {
            title: '생성일자',
            key: 'firstRegTime',
            dataIndex: 'firstRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>

        },
        {
            title: '수정일자',
            key: 'lastRegTime',
            dataIndex: 'lastRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_STORAGE_MGR) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => {openModifyModal(record)}}>수정</Button>
                    <Button type="link" size="small" onClick={() => {onDelete(record)}}>삭제</Button>
                </div>

        },

    ];


    const onDelete = (record:TB_STORAGE_MGR) => {

        Modal.confirm({
            title: `아카이빙 설정을 삭제하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADD03`, requestBody:record }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };



    function openRegModal()
    {
        setIsModifyMode(false);
        setMainPath('');
        setStorageName('');
        setLimitCnt(1000);
        setLimitFileSize( 2 );
        setShowModal(true);
    }

    function openModifyModal(recode:TB_STORAGE_MGR)
    {
        const isGB:boolean = bytesToFileSizeString(recode.limitFileSize).includes("GB");
        setCalcFilesize(isGB ? "GB" : "MB");
        setIsModifyMode(true);
        setMainPath(recode.mainPath);
        setStorageName(recode.storageName);
        setLimitCnt(recode.limitCnt);
        setLimitFileSize( isGB ? recode.limitFileSize /1024 /1024 /1024 : recode.limitFileSize /1024 /1024);
        setShowModal(true);
    }

    function onSaveArchive()
    {
        const requestParam:TB_STORAGE_MGR = {
            storageName:storageName,
            limitCnt:limitCnt,
            limitFileSize:calcFilesize === "MB" ?  limitFileSize *1024 *1024 : limitFileSize *1024 *1024 *1024,
            mainPath:mainPath.replaceAll("\\", "/"),
        }
        Modal.confirm({
            title: `아카이빙설정을 저장하시겠습니까?`,
            content: "",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU09`, requestBody:requestParam }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                        setShowModal(false);
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });
    }



    const fields = [
        { name: ['storageName'], value: storageName },
        { name: ['mainPath'], value: mainPath },
        { name: ['limitCnt'], value: limitCnt },
        { name: ['limitFileSize'], value: limitFileSize },
    ];


    return (
        <>
            <nav style={{
                margin:'0px 0px 14px 0px',
                padding:'9px 8px 9px 0px',
                height: '50px',
                display:'flex',
                justifyContent: "space-between",
                alignItems:'center',
                borderRadius: "8px", // 라운드 처리 추가
                border: '1px solid #dadada',
                background: colorBgContainer,
            }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{
                        padding: '9px 5px',
                        display:'flex',
                    }}>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Button style={{marginRight:"10px"}} type={"primary"} onClick={openRegModal}>아카이빙등록</Button>
                </div>
            </nav>
        <Table columns={columns}
            dataSource={data}
            rowKey="storageName"
            loading={isFetching}
        />

            <Modal
                open={showModal}
                title="아카이브정보등록"
                onCancel={()=>{setShowModal(false)}}
                footer={[
                    <></>
                ]}
            >
                <Form
                    fields={fields}
                    name="saveArchive"
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveArchive}
                >
                    <Form.Item
                        label={"아카이브명"}
                        name="storageName"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        {
                            isModifyMode ?
                                <Input
                                    readOnly
                                    prefix={<EditOutlined className="site-form-item-icon" />}
                                    placeholder="아카이브명"
                                    value={storageName}
                                    onChange={(e)=>setStorageName(e.target.value)}
                                />
                                :
                                <Input
                                    prefix={<EditOutlined className="site-form-item-icon" />}
                                    placeholder="아카이브명"
                                    value={storageName}
                                    onChange={(e)=>setStorageName(e.target.value)}
                                />
                        }


                    </Form.Item>
                    <Form.Item
                        label={"저장경로"}
                        name="mainPath"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="저장경로"
                            value={mainPath}
                            onChange={(e)=>setMainPath(e.target.value)}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"폴더당파일개수"}
                        name="limitCnt"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="폴더당파일개수"
                            value={limitCnt}
                            onChange={(e)=>setLimitCnt(parseInt(e.target.value))}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"폴더당파일크기"}
                        name="limitFileSize"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Select
                            defaultValue="GB"
                            style={{ width: 80 }}
                            onChange={(value)=>{{ setCalcFilesize(value) }}}
                            options={[
                                { value: 'MB', label: 'MB' },
                                { value: 'GB', label: 'GB' },
                            ]}
                        />
                        <Input
                            style={{width : "276px", marginLeft: "6px"}}
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="폴더당파일크기"
                            value={limitFileSize}
                            onChange={(e)=>setLimitFileSize( parseInt(e.target.value))}
                        />

                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ArchiveMgr;
